(function () {
	if (window.__mediaBannerInit) return;
	window.__mediaBannerInit = true;

	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");

			const stickyEffect = block.dataset.stickyEffect === "true";

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	/* ── Video Lazy Load: only play videos visible in viewport ── */
	const videoLazyLoad = () => {
		const videos = document.querySelectorAll('.media-banner__video video');
		if (!videos.length) return;

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const video = entry.target;
				if (entry.isIntersecting) {
					// Entering viewport — restore sources and play
					const sources = video.querySelectorAll('source[data-lazy-src]');
					sources.forEach((source) => {
						source.src = source.dataset.lazySrc;
						source.removeAttribute('data-lazy-src');
					});
					if (video.dataset.lazySrc) {
						video.src = video.dataset.lazySrc;
						delete video.dataset.lazySrc;
					}
					if (sources.length) video.load();
					video.play().catch(function() {});
				} else {
					// Leaving viewport — pause to save memory
					video.pause();
				}
			});
		}, {
			rootMargin: '300px' // start loading 300px before visible
		});

		videos.forEach((video, index) => {
			if (video.dataset.lazyObserved) return;
			video.dataset.lazyObserved = '1';

			// First video (index 0 or 1 for desktop/mobile pair) — keep playing
			var rect = video.getBoundingClientRect();
			var isFirstScreen = rect.top < window.innerHeight && rect.bottom > 0;

			if (!isFirstScreen) {
				// Strip sources to prevent download
				video.pause();
				var sources = video.querySelectorAll('source');
				sources.forEach((source) => {
					const s = source.getAttribute('src');
					if (s) {
						source.dataset.lazySrc = s;
						source.removeAttribute('src');
					}
				});
				const videoSrc = video.getAttribute('src');
				if (videoSrc) {
					video.dataset.lazySrc = videoSrc;
					video.removeAttribute('src');
				}
				video.load(); // reset to stop any in-progress download
			}

			observer.observe(video);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		mediaBanner();
		videoLazyLoad();
		document.addEventListener("shopify:section:load", function () {
			mediaBanner();
			videoLazyLoad();
		});
	});
})();
